'use client'

import { useEffect } from 'react'

export default function ChunkErrorHandler() {
  useEffect(() => {
    // Handle chunk loading errors
    const handleChunkError = (event: ErrorEvent) => {
      const error = event.error || event.message || ''
      const isChunkError = 
        typeof error === 'string' && 
        (error.includes('Loading chunk') || 
         error.includes('Failed to fetch dynamically imported module') ||
         error.includes('ChunkLoadError') ||
         error.match(/\/\.[0-9a-f]+\.js/))

      if (isChunkError) {
        console.warn('Chunk loading error detected, reloading page...', error)
        // Reload the page to get fresh chunks
        window.location.reload()
        return true
      }
      return false
    }

    // Handle unhandled promise rejections (common for chunk errors)
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error = event.reason?.message || event.reason || ''
      const isChunkError = 
        typeof error === 'string' && 
        (error.includes('Loading chunk') || 
         error.includes('Failed to fetch dynamically imported module') ||
         error.includes('ChunkLoadError') ||
         error.match(/\/\.[0-9a-f]+\.js/))

      if (isChunkError) {
        console.warn('Chunk loading error detected in promise rejection, reloading page...', error)
        event.preventDefault() // Prevent default error handling
        window.location.reload()
        return true
      }
      return false
    }

    // Add event listeners
    window.addEventListener('error', handleChunkError, true)
    window.addEventListener('unhandledrejection', handleUnhandledRejection)

    // Cleanup
    return () => {
      window.removeEventListener('error', handleChunkError, true)
      window.removeEventListener('unhandledrejection', handleUnhandledRejection)
    }
  }, [])

  return null
}

